import { render } from "./biRateSettings.vue?vue&type=template&id=a9efddaa&scoped=true"
import script from "./biRateSettings.vue?vue&type=script&lang=js"
export * from "./biRateSettings.vue?vue&type=script&lang=js"

import "./biRateSettings.vue?vue&type=style&index=0&id=a9efddaa&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9efddaa"]])

export default __exports__